import { create } from "zustand";

const VendorStore = create((set) => ({
  selectedVendor: null,

  setSelectedVendor: (vendor) =>
    set({ selectedVendor: vendor }),

  clearSelectedVendor: () =>
    set({ selectedVendor: null }),
}));

export default VendorStore;